import React from 'react';
import Logo from '../../components/common/Logo';
import AdminSidebar from '../../components/dashboard-admin/AdminSidebar';
import { useParams } from 'react-router-dom';
import SurveyQuestions from '../../components/survey-questions/SurveyQuestions';
import EditQuestion from '../../components/survey-questions/EditQuestion';

const AdminSurveyPage = () => {
  const { id } = useParams();
  
  // Determina se stiamo creando o modificando
  const isCreating = id === 'new';
  const isEditing = id && id !== 'new';
  
  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <div className="w-64 bg-white shadow-md">
        <div className="p-4">
          <Logo />
        </div>
        <AdminSidebar />
      </div>
      
      {/* Main content */}
      <div className="flex-1 bg-gray-50 p-8">
        <header className="mb-8">
          <h1 className="text-2xl font-bold">
            {isCreating ? 'Crea Nuova Domanda' : isEditing ? 'Modifica Domanda' : 'Gestione Questionario'}
          </h1>
          <p className="text-gray-600">
            {isCreating || isEditing ? 'Compila il form per configurare la domanda' : 'Visualizza, modifica e organizza le domande del questionario'}
          </p>
        </header>
        
        {/* Contenuto dinamico */}
        {isCreating ? (
          <EditQuestion isNew={true} />
        ) : isEditing ? (
          <EditQuestion isNew={false} questionId={id} />
        ) : (
          <SurveyQuestions />
        )}
      </div>
    </div>
  );
};

export default AdminSurveyPage;